import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    removeRow(event) {
        event.currentTarget.closest("tr").remove()
    }
}
